/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import apiDecorator from 'api/api-decorator';

import AbstractInput from '../abstractInput';

import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/lib/codemirror.css';

const modes = {
  php: 'text/x-php',
  javascript: 'javascript'
};

@apiDecorator
class Code extends AbstractInput {
  static propTypes = {
    ...AbstractInput.propTypes,
    className: PropTypes.string,
    lang: PropTypes.oneOf(['javascript', 'php']).isRequired,
    // Class name for $this-> autocomplete in PHP
    thisClass: PropTypes.string
  };

  constructor(props, context) {
    super(props, context);
    this.onChange = this.onChange.bind(this);
    this.Editor = null;
    this.ref = null;
    this.domNode = null;
    this.state = {
      initialized: false
    };
    this.classHierarchy = null;
    this.dataProviderMethods = null;
    this.handleChange = this.handleChange.bind(this);
    this.autocomplete = this.autocomplete.bind(this);
  }

  componentDidMount() {
    if (this.props.lang === 'php') {
      this.api.get('action/helpers/code-mirror/class-hierarchy')
        .then(resp => this.classHierarchy = resp);
    }

    Promise.all([
      import('codemirror'),
      import('codemirror/mode/php/php.js'),
      import('codemirror/mode/javascript/javascript.js'),
      import('codemirror/addon/hint/show-hint.js'),
    ])
      .then((imp) => {
      const CodeMirror = imp[0].default;
        this.Editor = CodeMirror(this.ref, {
          lineSeparator: "\n",
          indentUnit: 4,
          smartIndent: true,
          tabSize: 4,
          indentWithTabs: false,
          lineNumbers: true,
          fixedGutter: true,
          value: this.props.value || '',
          mode: modes[this.props.lang],
          extraKeys: {"Ctrl-Space": "autocomplete"},
          hintOptions: {
            hint: this.autocomplete,
            completeSingle: false,
          }
        });
        this.Editor.setSize('100%', '100%');
        this.Editor.on('change', this.handleChange);
        this.setState({ initialized: true });
      });
  }

  componentDidUpdate() {
    if (this.Editor) {
      if (this.Editor.getValue() !== this.props.value) {
        this.Editor.setValue(this.props.value || '');
      }
    }
  }

  handleChange(cm) {
    if (this.$set) {
      return null;
    }
    this.props.onChange(cm.getValue());
  }

  /**
   * TODO Блэкджэк и шлюхи. Запилить когда будет время
   * @param cm
   * @param opts
   * @param word
   * @param from
   * @param to
   * @return {{list: [string,string], from: *, to: *}}
   */
  phpAutocomplete(cm, opts, word, from, to) {
    console.log('phpAutocomplete - ', word);

    let res = null;
    if ((res = word.match(/\$this->(.*)/))) {
      console.log('MATCH THIS', res);
    }

    return { list: ['lol', 'trololo'], from, to };
    //return new Promise((accept, reject) => setTimeout(() => accept({list: ['lol', 'trololo'], from, to}), 500));
  }

  autocomplete(cm, opts) {
    const cursor = cm.getCursor();
    const line = cm.getLine(cursor.line);
    let start = cursor.ch;
    let end = cursor.ch;

    while (start && /\S/.test(line.charAt(start - 1))) {
      --start;
    }
    while (end < line.length && /\S/.test(line.charAt(end))) {
      ++end;
    }
    const word = line.slice(start, end);

    return this[`${this.props.lang}Autocomplete`](
      cm,
      opts,
      word,
      {line: cursor.line, start},
      {line: cursor.line, end}
    );
  }

  onChange(event) {

  }

  render() {
    const { className } = this.props;
    return (
      <div
        className={className ? `code-editor ${className}` : 'code-editor'}
        ref={(el) => this.ref = el || this.ref}
        style={{ border: '.1rem solid #ccc', height: 'auto', flexGrow: 8, zIndex: 0 }}
      />
    );
  }
}
export default Code;
